import React, { useEffect, useRef } from 'react';

interface ModalProps {
  onClose: () => void;
  children: React.ReactNode;
  title?: string;
  footer?: React.ReactNode;
  headerExtra?: React.ReactNode;
  size?: "sm" | "md" | "lg";
}

const ModalWrapper: React.FC<ModalProps> = ({ onClose, children, title, footer, headerExtra, size = "md" }) => {
  const modalContentRef = useRef<HTMLDivElement>(null);
   const maxWidth =
    size === "sm" ? "28rem" : size === "lg" ? "38rem" : "34rem";
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (modalContentRef.current && !modalContentRef.current.contains(event.target as Node)) {
        onClose();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [onClose]);

  return (
    <div data-state="open" className="_Overlay_1699y_1" style={{ pointerEvents: 'auto' }}>
      <div
        role="dialog"
        id="radix-1045"
        aria-describedby="radix-1060"
        aria-labelledby="radix-1059"
        data-state="open"
        className="_Content_1699y_16"
        tabIndex={-1}
        style={{ pointerEvents: 'auto', maxWidth }}
      >
        <div
          ref={modalContentRef}
          className={`_ModalContent_1mwy7_23 tw-flex tw-flex-col ${
            size === "sm"
              ? "max-w-md"
              : size === "lg"
              ? "max-w-3xl"
              : "max-w-xl"
          }`}
        >
          <div className="tw-flex tw-justify-end">
            <button
              className="btn-reset tw-bg-white tw-px-0 tw-text-gray-600 tw-sticky tw-right-0 tw-top-0"
              type="button"
              onClick={onClose}
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" className="tw-text-primary-500 tw-font-light">
                <path d="M17 7L7 17" stroke="#731054" strokeWidth="1.25" strokeLinecap="round" />
                <path d="M7 7L17 17" stroke="#731054" strokeWidth="1.25" strokeLinecap="round" />
              </svg>
            </button>
          </div>
          {headerExtra && <div className="tw-mb-4">{headerExtra}</div>}
          {title && (
            <header className="tw-text-center tw-mb-8 tw-text-gray-600 tw-z-20 tw-bg-white">
              <h3 className="h4 tw-mb-2">{title}</h3>
            </header>
          )}
          <div className="tw-grow tw-flex tw-flex-col">
            {children}
          </div>
          {footer && (
            <footer className="tw-mt-6 tw-flex tw-flex-wrap tw-justify-between tw-gap-3">
              {footer}
            </footer>
          )}
        </div>
      </div>
    </div>
  );
};

export default ModalWrapper;